import React from 'react'

export const HealthCheck = () => {
  return (
    <div style={{ fontSize: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>Server is up and running</div>
  )
}
